import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = ({ contact }) => {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <h2 className="text-3xl font-light tracking-wide">
                <span className="text-white">eco</span>
                <span className="text-green-500 font-medium">logical</span>
              </h2>
            </div>
            <p className="text-slate-300 leading-relaxed mb-6 font-light">
              UK-based consultancy specialising in onshore wind, commercial solar, energy storage and power infrastructure.
            </p>
            <div className="flex flex-col space-y-3">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                  <span className="text-xs font-semibold">40+</span>
                </div>
                <span className="text-slate-300 font-light">Wind Turbines</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                  <span className="text-xs font-semibold">50+</span>
                </div>
                <span className="text-slate-300 font-light">Solar PV projects</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-medium mb-6">Core Services</h3>
            <ul className="space-y-3 text-slate-300 font-light">
              <li>Planning & Permissions</li>
              <li>Grid Connection & Export</li>
              <li>Project Financing</li>
              <li>Onshore Wind Development</li>
              <li>Commercial Solar Solutions</li>
              <li>Energy Storage Systems</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-medium mb-6">Contact Information</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-green-500 mt-0.5" />
                <div>
                  <div className="font-medium">Email</div>
                  <a 
                    href="mailto:info@ecological.energy" 
                    className="text-slate-300 font-light hover:text-white transition-colors no-underline"
                  >
                    info@ecological.energy
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-green-500 mt-0.5" />
                <div>
                  <div className="font-medium">Phone</div>
                  <div className="text-slate-300 font-light">+44(0)1392 249230</div>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-green-500 mt-0.5" />
                <div>
                  <div className="font-medium">Address</div>
                  <div className="text-slate-300 font-light">{contact.address}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-slate-400 text-sm font-light">
              © 2024 Ecological Energy. All rights reserved.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link 
                to="/privacy-policy" 
                className="text-slate-400 hover:text-white text-sm font-light transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-of-service" 
                className="text-slate-400 hover:text-white text-sm font-light transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};